<template>
  <transition name="fade">
      <div class="modal-mask" v-show="showModal"  @click.self="closeModal">
          <div class="message-box" :class="{ show: showModal }">
              <h2 class="message-title">噪音分析说明</h2>
              <div class="message-content">
                <p style="font-weight: bold;">

                  噪音分析是以小区周围道路为噪音源，测算马路声音传播至墙面时的声音。即开窗时的声音，如关闭窗户噪音可减弱
                </p>
                <p>
                  0-20(dB)：极静，近乎完全无声的环境。如隔音室、自己的呼吸声。
                </p>
                <p>
                  20-30(dB)：非常安静，如耳语声、图书馆内的翻书声。
                </p>
                <p>
                  30-40(dB)：安静，如安静的办公室、冰箱的嗡嗡声、清晨的居民区（无交通时）。
                </p>
                <p>
                  40-50(dB)：轻度干扰,如室内空调声、细雨声、普通的室内谈话声。
                </p>
                <p>
                  50-60(dB)：中度干扰，如普通洗衣机的工作声、远处的吸尘器声。
                </p>
                <p>
                  60-70(dB)：嘈杂，如面对面正常交谈声、闹市区的街道。
                </p>
                <p>
                  70-80(dB)：很吵，如城市主干道交通声、真空吸尘器声、大声的电视机。
                </p>
                <p>
                  80-90(dB)：极吵，如地铁进站声、割草机声、厨房搅拌机声。
                </p>
                <p>
                  90-100(dB)：有害噪音，如飞机起飞、酒吧或迪厅内的音乐。
                </p>
              </div>
              <button class="close-btn" @click="closeModal">了解了</button>
          </div>
      </div>
  </transition>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
      // this.showModal = false;
    }
  },
}
</script>

<style scoped>
  /* 蒙版样式 */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* 确保足够高的z-index */
    transition: opacity 0.3s;
  }
  /* 消息框样式 */
  .message-box {
    background: white;
    width: 80%;
    height: 50%;
    /* max-width: 450px; */
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
    transform: scale(0.7);
    transition: all 1s ease;
    color: #333;
  }
  
  .message-box.show {
    transform: scale(1);
  }

  .message-title {
    height: 10%;
    font-size: 1.8rem;
    margin: 10px;
    color: #2575fc;
    font-weight: 600;
  }
  
  .message-content {
    height: 70%;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 25px;
    color: #555;
    overflow-y: auto;
  }

  .message-content p {
    text-align: left;
  }

  .close-btn {
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    color: white;
    border: none;
    padding: 12px 30px;
    font-size: 1.1rem;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
  }

  .close-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(37, 117, 252, 0.4);
  }
  /* 动画效果 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>